import { GetFollowRequestsResponseModel } from './../../../core/model/api-response/blog-response-model';
import { BlogUserModel } from './../../../core/model/object/blog-user-model';
import { BlogPostModel } from 'src/app/core/model/object/blog-model';
import { BlogShared } from './../../general/shared/blog-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { LoadingShared } from 'src/app/presentation/general/shared/loading-shared';
import { ActivityModel } from './../../../core/model/object/blog-model';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { Component, Input, OnInit } from '@angular/core';
import { DateHelper } from 'src/app/utils/date-helper';
import { BlogDataService } from 'src/app/data/repository/blog-repository/blog-data.service';

@Component({
  selector: 'app-blog-activity',
  templateUrl: './blog-activity.component.html',
  styleUrls: ['./blog-activity.component.scss'],
})
export class BlogActivityComponent implements OnInit {
  @Input() id: number = 10;

  dataIsReady = false;
  selectedUsername = '';
  selectedPost: BlogPostModel;
  profileId = 11;
  detailId = 11;
  requestsId = 11;
  showRequests = false;
  showProfile = false;
  showDetail = false;

  activitiesPerPage = 30;
  activitiesPage = 0;
  activitiesCount = 0;
  activities: ActivityModel[] = [];

  activityDateLabel: string[] = [];

  followRequests: BlogUserModel[];
  followRequestsCount = 0;

  constructor(
    private blogService: BlogService,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService,
    public dateHelper: DateHelper,
    public blogShared: BlogShared,
    private blogDataService: BlogDataService
  ) {
    this.load();
  }

  ngOnInit() {}

  load() {
    this.loadingShared.showLoading();
    this.blogService
      .getActivityList(this.activitiesPage, this.activitiesPerPage)
      .then((res) => {
        if (res.isSuccess()) {
          this.activities = res.getData().getBlogActivityList().activities;
          this.activitiesCount = res.getData().getBlogActivityList().count;
          this.blogService.getFollowRequests(0, 20).then((result) => {
            if (result.isSuccess()) {
              this.followRequests = result
                .getData()
                .getBlogFollowRequests().followers;
              this.followRequestsCount = result
                .getData()
                .getBlogFollowRequests().count;
              this.dataIsReady = true;
            } else {
              this.snackBarService.showSnackBar(
                'خطا در برقراری ارتباط با سرور!'
              );
            }
          });
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.loadingShared.hideLoading();
      });
  }

  showMoreActivities() {
    this.loadingShared.showLoading();
    this.activitiesPage++;
    this.blogService
      .getActivityList(this.activitiesPage, this.activitiesPerPage)
      .then((res) => {
        if (res.isSuccess()) {
          this.activities = [
            ...this.activities,
            ...res.getData().getBlogActivityList().activities,
          ];
          this.activitiesCount = res.getData().getBlogActivityList().count;
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.loadingShared.hideLoading();
      });
  }
  closeActivity() {
    this.blogService.goback();
  }
  showActivity(activity: ActivityModel) {
    console.log(activity);

    if (activity.entity === 'LIKE_POST') {
    } else if (
      activity.entity === 'COMMENT' ||
      activity.entity === 'REPLY' ||
      activity.entity === 'MENTION'
    ) {
      this.openDetailComments(activity.post);
    } else {
      this.profile(activity.user.userName);
    }
  }

  acceptFollowing(userId: string) {
    this.blogService.setFollowRequest(userId, 'accept').then((res) => {
      if (res.isSuccess()) {
        for (let i = 0; i < this.activities.length; i++) {
          if (
            this.activities[i].user.id === userId &&
            this.activities[i].entity === 'FOLLOW_REQUEST'
          ) {
            this.activities.splice(i, 1);
            break;
          }
        }
        for (let i = 0; i < this.followRequests.length; i++) {
          if (this.followRequests[i].id === userId) {
            this.followRequests.splice(i, 1);
            break;
          }
        }
        this.followRequestsCount--;
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
    });
  }

  rejectFollowing(userId: string) {
    this.blogService.setFollowRequest(userId, 'ignore').then((res) => {
      if (res.isSuccess()) {
        for (let i = 0; i < this.activities.length; i++) {
          if (
            this.activities[i].user.id === userId &&
            this.activities[i].entity === 'FOLLOW_REQUEST'
          ) {
            this.activities.splice(i, 1);
            break;
          }
        }
        for (let i = 0; i < this.followRequests.length; i++) {
          if (this.followRequests[i].id === userId) {
            this.followRequests.splice(i, 1);
            break;
          }
        }
        this.followRequestsCount--;
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
    });
  }

  profile(username: string) {
    this.blogService.goToUserProfile(username);

    // this.selectedUsername = username;
    // this.blogShared.blogZIndex++;
    // this.profileId = this.blogShared.blogZIndex;
    // this.showProfile = true;
    // setTimeout(() => {
    //   document.getElementById('profilePage' + this.id).style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('profilePage' + this.id).style.right = '0';
    // }, 100);
  }

  closeProfile() {
    this.blogShared.blogZIndex--;
    document.getElementById('profilePage' + this.id).style.right = '100%';
    this.load();
    // this._sharedService.animateDownButton();
    setTimeout(() => {
      this.showProfile = false;
    }, 300);
  }

  openRequests() {
    this.blogShared.blogZIndex++;
    this.requestsId = this.blogShared.blogZIndex;
    this.showRequests = true;
    setTimeout(() => {
      document.getElementById('followRequests').style.zIndex =
        this.blogShared.blogZIndex.toString();
      document.getElementById('followRequests').style.right = '0';
    }, 100);
  }

  closeRequests() {
    this.blogShared.blogZIndex--;
    document.getElementById('followRequests').style.right = '100%';
    // this._sharedService.animateDownButton();
    this.load();
    setTimeout(() => {
      this.showRequests = false;
    }, 300);
  }

  async openDetail(postId: string) {
    await this.blogService.getBlogPost(postId).then((res) => {
      if (res.isSuccess()) {
        const post = res.getData().getBlogPost();
        this.blogDataService.setPost(post);
        this.blogService.goToUserPost(post.user.userName, post.id);
      }
    });
  }

  async openDetailComments(postId: string) {
    await this.blogService.getBlogPost(postId).then((res) => {
      if (res.isSuccess()) {
        const post = res.getData().getBlogPost();
        this.blogDataService.setScroolStatus(true);
        this.blogDataService.setPost(post);
        this.blogService.goToUserPost(post.user.userName, post.id);
      }
    });
  }

  closeDetail() {
    this.blogShared.blogZIndex--;
    document.getElementById('botomsheet' + this.id).style.top = '100%';
    setTimeout(() => {
      this.showDetail = false;
    }, 300);
  }
}
